var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1178_11627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.55229 0 7 0.447715 7 1L7 3H13L13 1C13 0.447715 13.4477 0 14 0C14.5523 0 15 0.447715 15 1V3L15.0658 3C15.9523 2.99995 16.7161 2.99991 17.3278 3.08214C17.9833 3.17027 18.6117 3.36902 19.1213 3.87868C19.631 4.38834 19.8297 5.01669 19.9179 5.67221C20.0001 6.28387 20.0001 7.0477 20 7.93419L20 8V15L20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20L15 20H5L4.9342 20C4.0477 20.0001 3.28388 20.0001 2.67221 19.9179C2.0167 19.8297 1.38835 19.631 0.878684 19.1213C0.369022 18.6117 0.170277 17.9833 0.0821451 17.3278C-9.0407e-05 16.7161 -4.76109e-05 15.9523 2.45705e-06 15.0658L4.60281e-06 15V8L2.45705e-06 7.93417C-4.76109e-05 7.04768 -9.0407e-05 6.28387 0.0821451 5.67221C0.170277 5.01669 0.369022 4.38834 0.878684 3.87868C1.38835 3.36902 2.0167 3.17027 2.67221 3.08214C3.28387 2.99991 4.04769 2.99995 4.93417 3L5 3L5 1C5 0.447715 5.44772 0 6 0ZM13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15.9711 5 16.5988 5.00212 17.0613 5.06431C17.495 5.12262 17.631 5.21677 17.7071 5.29289C17.7832 5.36902 17.8774 5.50496 17.9357 5.9387C17.9979 6.40121 18 7.02892 18 8H2C2 7.02892 2.00213 6.40121 2.06431 5.9387C2.12263 5.50496 2.21677 5.36902 2.2929 5.29289C2.36902 5.21677 2.50497 5.12262 2.93871 5.06431C3.40121 5.00212 4.02893 5 5 5C5 5.55228 5.44772 6 6 6C6.55229 6 7 5.55228 7 5H13ZM2 15V10H18V15C18 15.9711 17.9979 16.5988 17.9357 17.0613C17.8774 17.495 17.7832 17.631 17.7071 17.7071C17.631 17.7832 17.495 17.8774 17.0613 17.9357C16.5988 17.9979 15.9711 18 15 18H5C4.02893 18 3.40121 17.9979 2.93871 17.9357C2.50497 17.8774 2.36902 17.7832 2.2929 17.7071C2.21677 17.631 2.12263 17.495 2.06431 17.0613C2.00213 16.5988 2 15.9711 2 15ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H7Z",
    fill: "#919191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1178_11627",
    x: 0,
    y: 0,
    width: 20.3333,
    height: 20.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1178_11627"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5404d704001db815208f12da316b4d9b.svg";
export { ForwardRef as ReactComponent };